// extracted by mini-css-extract-plugin
export default {"svg-polygon":"SiloSvg_svg-polygon__z5ykb"};